import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { gsap, Power4 } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import useWindowDimensions from "../components/hooks/useWindowDimensions";

function Missions() {
  gsap.registerPlugin(ScrollTrigger);
  const { width } = useWindowDimensions(); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (width > 560) {
      smoothscroll("#main-container");
    }

    function smoothscroll(content, viewport, smoothness) {
      gsap.registerPlugin(ScrollTrigger);
      content = gsap.utils.toArray(content)[0];
      smoothness = smoothness || 1;

      gsap.set(viewport || content.parentNode, {
        overflow: "hidden",
        position: "fixed",
        height: "100%",
        width: "100%",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      });
      gsap.set(content, { overflow: "visible", width: "100%" });

      let getProp = gsap.getProperty(content),
        setProp = gsap.quickSetter(content, "y", "px"),
        setScroll = ScrollTrigger.getScrollFunc(window),
        removeScroll = () => (content.style.overflow = "visible"),
        killScrub = (trigger) => {
          let scrub = trigger.getTween
            ? trigger.getTween()
            : gsap.getTweensOf(trigger.animation)[0]; // getTween() was added in 3.6.2
          scrub && scrub.kill();
          trigger.animation.progress(trigger.progress);
        },
        height,
        isProxyScrolling;

      function refreshHeight() {
        height = content.clientHeight;
        content.style.overflow = "visible";
        document.body.style.height = height + "px";
        return height - document.documentElement.clientHeight;
      }

      ScrollTrigger.addEventListener("refresh", () => {
        removeScroll();
        requestAnimationFrame(removeScroll);
      });
      ScrollTrigger.defaults({ scroller: content });
      ScrollTrigger.prototype.update = (p) => p; // works around an issue in ScrollTrigger 3.6.1 and earlier (fixed in 3.6.2, so this line could be deleted if you're using 3.6.2 or later)

      ScrollTrigger.scrollerProxy(content, {
        scrollTop(value) {
          if (arguments.length) {
            isProxyScrolling = true; // otherwise, if snapping was applied (or anything that attempted to SET the scroll proxy's scroll position), we'd set the scroll here which would then (on the next tick) update the content tween/ScrollTrigger which would try to smoothly animate to that new value, thus the scrub tween would impede the progress. So we use this flag to respond accordingly in the ScrollTrigger's onUpdate and effectively force the scrub to its end immediately.
            setProp(-value);
            setScroll(value);
            return;
          }
          return -getProp("y");
        },
        scrollHeight: () => document.body.scrollHeight,
        getBoundingClientRect() {
          return {
            top: 0,
            left: 0,
            width: window.innerWidth,
            height: window.innerHeight,
          };
        },
      });

      return ScrollTrigger.create({
        animation: gsap.fromTo(
          content,
          { y: 0 },
          {
            y: () => document.documentElement.clientHeight - height,
            ease: "none",
            onUpdate: ScrollTrigger.update,
          }
        ),
        scroller: window,
        invalidateOnRefresh: true,
        start: 0,
        end: refreshHeight,
        refreshPriority: -999,
        scrub: smoothness,
        onUpdate: (self) => {
          if (isProxyScrolling) {
            killScrub(self);
            isProxyScrolling = false;
          }
        },
        onRefresh: killScrub, // when the screen resizes, we just want the animation to immediately go to the appropriate spot rather than animating there, so basically kill the scrub.
      });
    }
  }, [width]);

  useEffect(() => {
    const tl = gsap.timeline();
    tl.staggerFrom(".hidetext", 1.5, { y: 200, ease: Power4.easeOut }, 0.35);
  }, []);

  return (
    <div id="main-container">
      <Header />
      <div className="max-w-[1300px] 2xl:mx-auto md:mx-[3rem] mx-[1.5rem] py-[5rem]">
        <div className="md:my-[5rem] mb-[4rem] uppercase w-full">
          <h1 className="font-bold lg:text-[6rem] md:text-[5rem] text-[35px] font-headerFont  relative overflow-hidden w-full lg:h-[140px] md:h-[100px] h-[50px]">
            <span className="absolute z-[200] hidetext">A Run</span>
          </h1>
          <h1 className="font-bold lg:text-[6rem] md:text-[5rem] text-[35px] font-headerFont relative overflow-hidden w-full lg:h-[200px] md:h-[250px] h-[100px] ">
            <span className="absolute z-[200] hidetext">Can Last Forever.</span>
          </h1>
        </div>
        <div>
          <img
            src="https://cdn.shopify.com/s/files/1/0564/0830/9941/files/moe7857_1920x.jpg?v=1647640079"
            alt="img"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="grid grid-cols-12 mt-[5rem] md:gap-[3rem]">
          <div className="md:col-span-4 md:block hidden">
            <img
              src="https://cdn.shopify.com/s/files/1/0564/0830/9941/files/NR-SS22_RZ-W-1452_480x.jpg?v=1647618893"
              alt="sub"
              className="w-full  h-[300px] object-cover"
            />
          </div>
          <div className="md:col-span-8 col-span-12">
            <p className="md:text-[2rem] text-[1rem] font-myfont font-bold">
              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eos
              natus voluptates veritatis accusamus nam officia, vero veniam!
              Sint veritatis, odio, saepe voluptate, est quas incidunt amet
              veniam eius quo inventore.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Missions;
